<template>
    <mds-modal class="edit-preference-modal" action-required :title="getUILabel('preference_edit_preference')" :visible="visible">
        <mds-section>
            <mds-form>
                <mds-combo-box :label="this.getUILabel('preference_select_language')" :data-set="languageDataSet" v-model="selectedLanguageItems">
                </mds-combo-box>
            </mds-form>
            <template v-slot:mds-section-actions>
                <mds-button-container right-aligned>
                    <mds-button variation="secondary" @click="handleCancel">
                        {{ getUILabel("common_cancel") }}
                    </mds-button>
                    <mds-button variation="primary" @click="handleOK">
                        {{ getUILabel("common_ok") }}
                    </mds-button>
                </mds-button-container>
            </template>
        </mds-section>
    </mds-modal>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsComboBox from "@mds/combo-box";
import MdsModal from "@mds/modal";
import MdsForm from "@mds/form";
import MdsSection from "@mds/section";

export default {
    name: "preference-modal",
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    components: {
        MdsButton,
        MdsButtonContainer,
        MdsComboBox,
        MdsForm,
        MdsModal,
        MdsSection
    },
    model: {
        prop: "visible"
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const { languageId } = this.$store.state.preference;
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            selectedLanguageItems: [languageId]
        };
    },
    computed: {
        selectedLanguage() {
            return this.selectedLanguageItems && this.selectedLanguageItems[0];
        },
        languageDataSet() {
            return this.$store.getters["config/languageList"].map(item => {
                return {
                    text: item.label,
                    value: item.value
                };
            });
        }
    },
    methods: {
        handleCancel() {
            this.$emit("input", false);
        },
        handleOK(e) {
            const { languageId } = this.$store.state.preference;
            if (this.selectedLanguage !== languageId) {
                this.$emit("changeLanguage", this.selectedLanguage);
            }
            this.$emit("input", false);
        }
    }
};
</script>
